// extracted by mini-css-extract-plugin
export default {"editClient":"styles_editClient__YoEBz","inputWrapper":"styles_inputWrapper__NZr7x","input":"styles_input__Uo1Yq","clientInput":"styles_clientInput__VJT7r"};